import uniqid from 'uniqid'
import ProjectContainer from '../ProjectContainer/ProjectContainer'
import './Projects.css'

const Projects = ({ projects = [] }) => {
  if (!Array.isArray(projects) || projects.length === 0) return null

  return (
    <div className='about__details'>
      <section className='section projects' aria-labelledby='projects-title'>
        <h2 id='projects-title' className='section__title'>
          Featured Projects
        </h2>

        <div className='projects__grid'>
          {projects.map((project, idx) => (
            <div
              key={uniqid()}
              className='project__cell'
              style={{ '--i': idx }} // stagger timing
            >
              <ProjectContainer project={project} />
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default Projects
